import { render, staticRenderFns } from "./mcrButtonRouterLinkToPr.vue?vue&type=template&id=a23594aa&scoped=true"
import script from "./mcrButtonRouterLinkToPr.vue?vue&type=script&lang=js"
export * from "./mcrButtonRouterLinkToPr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23594aa",
  null
  
)

export default component.exports